import { Col, Container, Image, Row } from "react-bootstrap";
import Header from "../components/Header"
import { fetchPhotos } from "../contexts/fetchGalleryData";
import { useEffect, useState } from "react";
import { ImageContainerModal } from "../components/Modals";

// const images = [
//     `${process.env.PUBLIC_URL}/activities/1.jpg`,
//     `${process.env.PUBLIC_URL}/activities/2.jpg`,
//     `${process.env.PUBLIC_URL}/activities/3.jpg`,
//     `${process.env.PUBLIC_URL}/activities/4.jpg`
// ];

// const getResponsiveHeight = () => {
//     const width = window.innerWidth;
//     if (width < 768) return 200;
//     if (width < 992) return 350;
//     return 500;
// };


const PageGallery = () => {

    const [isShowM, setShowM] = useState(false);
    const [currentImg, setCurrentImg] = useState({});
    const [data, setData] = useState([]);
    const [currentUrl, setCurrentUrl] = useState("");

    const sortedData = [...data].sort((a, b) => {
        const dateA = a.date ? new Date(a.date).getTime() : 0;
        const dateB = b.date ? new Date(b.date).getTime() : 0;
        return dateB - dateA;
    });

    useEffect(() => {
        fetchPhotos(setData);
        return () => {
            setShowM(false);
            setCurrentImg({})
            setData([]);
            setCurrentUrl('');
        };
    }, []);

    useEffect(() => {
        console.log(data)
    }, [data])

    const handleShow = (imageData, url) => {
        setCurrentImg(imageData)
        setCurrentUrl(url)
        setShowM(true)
    }

    const displayDate = (date) => {
        const d = date.split('-')
        return d[2] + '-' + d[1] + '-' + d[0]
    }

    return (
        <div>
            <Header />
            <Container>
                {sortedData.map((d, i) => (
                    <Row key={i} className="mt-4" hidden={d.hidden}>
                        <Col className="main-comp" md={{span: 10, offset: 1}} xs='12'>
                            <h4>{d.title}</h4>
                            <hr />
                            <div hidden={!d.des} className="pb-2">
                                {d.des}
                            </div>
                            
                            <Row>
                                {d.urls?.map((url, j) => (
                                    <Col key={j} lg='3' md='4' sm='6' xs='12'>
                                        <Image 
                                            src={url.url} 
                                            thumbnail 
                                            onClick={() => handleShow(d, url.url)} 
                                            style={{ cursor: 'pointer', maxHeight: '400px', maxWidth: '95%' }} // Add pointer cursor
                                            alt=""
                                        />
                                        
                                    </Col>
                                ))}
                                <div className="text-end">
                                    <span className="date-muted">{displayDate(d.date)}</span>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                ))}
            </Container>
            <ImageContainerModal isShowM={isShowM} setShowM={setShowM} data={currentImg} url={currentUrl}/>
        </div>
    )
}


// const PageGalleryOld = () => {
//     return (
//         <div>
//             <Header />
//             <Container>
//             <Row>
//                 <Col xs='12' md={{offset: 2, span: 8}}>
//                     <Carousel fade interval={5000}>
//                         {images.map((src, i) => (
//                             <Carousel.Item key={i}>
//                                 <div className="carousel-img-wrapper">
//                                     <img src={src} alt={`Slide ${i + 1}`} />
//                                 </div>
//                             </Carousel.Item>
//                         ))}
//                     </Carousel>

//                 </Col>
//             </Row>
//             </Container>
//         </div>
//     )
// }
export default PageGallery